var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInstagramLogo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7665 0.00012207H4.70829C2.21752 0.00012207 0.179199 2.02445 0.179199 4.50012V13.5001C0.179199 15.9749 2.21752 18.0001 4.70829 18.0001H13.7665C16.2573 18.0001 18.2956 15.9749 18.2956 13.5001V4.50012C18.2956 2.02445 16.2573 0.00012207 13.7665 0.00012207ZM9.23673 12.75C7.15235 12.75 5.46307 11.0706 5.46307 9.00012C5.46307 6.92877 7.15235 5.25005 9.23673 5.25005C11.3202 5.25005 13.0104 6.92877 13.0104 9.00012C13.0104 11.0706 11.3202 12.75 9.23673 12.75ZM13.0121 4.12505C13.0121 4.74627 13.5182 5.25005 14.1439 5.25005C14.7696 5.25005 15.2757 4.74627 15.2757 4.12505C15.2757 3.50382 14.7696 3.00005 14.1439 3.00005C13.5182 3.00005 13.0121 3.50382 13.0121 4.12505Z",
    fill: "#1A1A1A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagramLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram-logo.21424000.svg";
export { ForwardRef as ReactComponent };